<script>
  import {onMount} from 'svelte';
  import {url} from '@sveltech/routify';

  import {nombreCompleto} from '../../Modelos/Trabajador';

  import ParrillaDeTrabajadores from "../../Components/Trabajadores/Parrilla/index.svelte";

  import Loading from "../../Components/UI/Loading.svelte";
  import Error from "../../Components/UI/Error.svelte";
  import Boton from "../../Components/UI/Boton.svelte";
  import Titulo from "../../Components/UI/Titulo.svelte";
  import Modal from "../../Components/UI/Modal.svelte";
  import Icono from "../../Components/UI/Icono.svelte";

  import trabajadores from '../../Stores/trabajadores-store';
  import storeGrupos from '../../Stores/grupos-store';

  import Caja from "../../Components/UI/Caja.svelte";
  import CampoDeTexto from "../../Components/UI/CampoDeTexto.svelte";
  import Subtitulo from "../../Components/UI/Subtitulo.svelte";
  import CampoDeSeleccion from "../../Components/UI/CampoDeSeleccion.svelte";
  import {creaOpciones} from "../../Utils/selects";
  import storeSedes from "../../Stores/sedes-store";

  onMount(() => {
    storeGrupos.cargar();
    storeSedes.cargar();
  });

  let grupos, opcionesDeGrupo, trabajadorEliminado, filtradosPorTexto, errorEliminacion,
      listadoFiltrado, sedesa, trabajadorRestaurado, errorRestauracion;
  $: grupos = $storeGrupos.listado;
  $: errorEliminacion = $storeGrupos.errorEliminacion;
  $: errorRestauracion = $storeGrupos.errorRestauracion;
  $: opcionesDeGrupo = creaOpciones($trabajadores.listado.filter(x => !x.grupo).length ?
      [{id: -1, nombre: 'Sin grupo', hijos: []}, ...grupos] : grupos
  );

  let activos = true;
  $: trabajadores.cargar(activos);

  let filtro = {
    texto: '',
    grupo: '',
    sede: ''
  };

  const actualizaFiltro = campo => ({target}) => {
    filtro = {
      ...filtro,
      [campo]: target.value
    }
  };

  $: error = $trabajadores.error;
  $: trabajadorEliminado = $trabajadores.trabajadorEliminando;
  $: trabajadorRestaurado = $trabajadores.trabajadorRestaurando;
  $: filtradosPorTexto = $trabajadores.listado.filter(x => {
    return filtro.texto === '' || nombreCompleto(x).toLowerCase().indexOf(filtro.texto.toLowerCase()) >= 0;
  });
  $: listadoFiltrado = filtradosPorTexto.filter(x => {
    return (filtro.grupo === '' && filtro.sede === '') ||
        (+filtro.grupo === -1 && !x.grupo) ||
        (x.grupo && x.grupo.id === +filtro.grupo) ||
        (x.sede && x.sede.id === +filtro.sede);
  });

  $: sedes = ($storeSedes.listado || []).map(sede => ({valor: sede.id, etiqueta: sede.nombre}));

  const eliminarTrabajador = e => trabajadores.eliminarTrabajador(e.detail);
  const eliminaTrabajadorDeVerdad = () => trabajadores.eliminaTrabajadorDeVerdad();
  const restaurarTrabajador = e => trabajadores.restaurarTrabajador(e.detail);
  const restauraTrabajadorDeVerdad = () => trabajadores.restauraTrabajadorDeVerdad();
</script>

<style>
    .nuevo-trabajador {
        margin: var(--padding-global) 0;
        display: flex;
        align-items: center;
    }

    .nuevo-trabajador-boton {
        margin-left: auto;
    }

    .filtro {
        margin-bottom: var(--padding-global);
    }

    .filtro-contenido {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        grid-gap: var(--padding-global);
    }

    .activo {
        display: flex;
        align-items: center;
        letter-spacing: .15em;
    }
</style>

<svelte:head>
    <title>Trabajadores</title>
</svelte:head>

<Titulo>Trabajadores</Titulo>

{#if error}
    <Error on:cancel={() => error = false}>{$trabajadores.error}</Error>
{/if}

<div class="contenido">
    {#if $trabajadores.cargando }
        <Caja cabecera={false}>
            <Loading/>
        </Caja>
    {:else if $trabajadores.listado }
        <div class="filtro">
            <Caja>
                <div slot="titulo">
                    <div style="display: flex; justify-content: space-between">
                        <Subtitulo>Filtro</Subtitulo>
                        <div class="activo">
                            <input type="radio" id="activos" value={true} bind:group={activos}>
                            <label for="activos">Activos</label>

                            <input type="radio" id="inactivos" value={false} bind:group={activos}>
                            <label for="inactivos">Inactivos</label>
                        </div>
                    </div>
                </div>

                <div class="filtro-contenido">
                    <CampoDeTexto icono="search" label="Nombre"
                                  value={filtro.texto} on:input={actualizaFiltro('texto')}/>

                    <CampoDeSeleccion id="padre" label="Sede"
                                      value={filtro.sede ? filtro.sede.id : ''}
                                      icono="account_tree" valido={true}
                                      opciones={sedes} vacio="Todas"
                                      on:input={actualizaFiltro('sede')}/>

                    <CampoDeSeleccion id="padre" label="Grupo"
                                      value={filtro.grupo ? filtro.grupo.id : ''}
                                      icono="account_tree" valido={true}
                                      opciones={opcionesDeGrupo} vacio="Todos"
                                      on:input={actualizaFiltro('grupo')}/>
                </div>
            </Caja>
        </div>

        <div class="nuevo-trabajador">
            {$trabajadores.listado.length} trabajadores
            {#if listadoFiltrado.length !== $trabajadores.listado.length}({listadoFiltrado.length} visibles){/if}

            <div class="nuevo-trabajador-boton">
                <Boton href="{$url('../nuevo')}">Nuevo trabajador</Boton>
            </div>
        </div>

        <ParrillaDeTrabajadores on:eliminar-trabajador={eliminarTrabajador}
                                on:restaurar-trabajador={restaurarTrabajador}
                                activos={activos}
                                trabajadores={listadoFiltrado}/>

        {#if listadoFiltrado.length > 6}
            <div class="nuevo-trabajador">
                <div class="nuevo-trabajador-boton">
                    <Boton href="{$url('../nuevo')}">Nuevo trabajador</Boton>
                </div>
            </div>
        {/if}
    {/if}
</div>

{#if trabajadorEliminado}
    <Modal title="¿Está seguro de que desea eliminar al trabajador {trabajadorEliminado.nombre} {trabajadorEliminado.apellidos}?"
           error={errorEliminacion}>
        <p>El trabajador se mantendrá en la sección <em>Inactivos</em>, donde podrá consultar todos
            sus
            fichajes durante el periodo establecido por ley, así como restaurarlo en cualquier
            momento.</p>

        <div slot="footer" class="opciones">
            <Boton on:click={eliminaTrabajadorDeVerdad} tipo="peligro">
                <Icono>check</Icono>
                Confirmar
            </Boton>
            <Boton on:click={() => trabajadorEliminado = false} tipo="neutral">
                <Icono>cancel</Icono>
                Cancelar
            </Boton>
        </div>
    </Modal>
{/if}


{#if trabajadorRestaurado}
    <Modal title="¿Está seguro de que desea restaurar al trabajador {trabajadorRestaurado.nombre} {trabajadorRestaurado.apellidos}?"
           error={errorRestauracion}>
        <p>El trabajador volverá a la sección <em>Activos</em>.</p>

        <div slot="footer" class="opciones">
            <Boton on:click={restauraTrabajadorDeVerdad} tipo="peligro">
                <Icono>check</Icono>
                Confirmar
            </Boton>
            <Boton on:click={() => trabajadorRestaurado = false} tipo="neutral">
                <Icono>cancel</Icono>
                Cancelar
            </Boton>
        </div>
    </Modal>
{/if}